import { Literal, Static, Union } from "runtypes";

import { SupportedMcpServerLiteral } from "../../../mcp-client";
import { ParameterInputTypeLiteral } from "../../../parameterType.js";

/**
 * Chart/visualization icon types
 */
export const ChartIconLiteral = Union(
  Literal("pivot-table"),
  Literal("sankey"),
  Literal("line"),
  Literal("area"),
  Literal("area_stacked"),
  Literal("area_stacked100"),
  Literal("scatter"),
  Literal("pie"),
  Literal("bar_grouped"),
  Literal("bar_stacked"),
  Literal("bar_stacked100"),
  Literal("column_grouped"),
  Literal("column_stacked"),
  Literal("column_stacked100"),
  Literal("combo"),
  Literal("histogram"),
);
export type ChartIcon = Static<typeof ChartIconLiteral>;

/**
 * Determines which icon will be shown on the tool call in the UI.
 */
export const ToolIconLiteral = Union(
  Literal("database"),
  Literal("search"),
  Literal("loading"),
  Literal("lightbulb"),
  Literal("task"),
  Literal("error"),
  Literal("markdown"),
  Literal("section"),
  Literal("sql"),
  Literal("python"),
  Literal("warning"),
  Literal("project"),
  Literal("success"),
  Literal("semantic-dataset"),
  Literal("run"),
  Literal("move"),
  Literal("metric"),
  Literal("filter"),
  Literal("sort"),
  Literal("attachment"), // deprecated, use "image" or "document" instead
  Literal("image"),
  Literal("document"),
  Literal("chart_cell"),
  Literal("git-repo"),
  Literal("github-repo"),
  Literal("gitlab-repo"),
  Literal("application"),
  Literal("console"),
  Literal("flag"),
  Literal("memory"),
  Literal("snapshot"),
  Literal("custom-mcp"),
  Literal("create"),
  Literal("edit"),
  Literal("eye"),
  Literal("trash"),
  Literal("duplicate"),
  Literal("arrow-right"),
  Literal("app"),
  ChartIconLiteral,
  ParameterInputTypeLiteral,
  SupportedMcpServerLiteral,
);

export type ToolIcon = Static<typeof ToolIconLiteral>;
